export const checkPermission = (userPermissions, category, permission) => {
  if (!userPermissions || !userPermissions[category]) {
    return false;
  }
  return userPermissions[category][permission] || false;
};

export const hasAnyCustomerPermission = (userPermissions) => {
  if (!userPermissions || !userPermissions.customers) {
    return false;
  }
  
  const customerPerms = userPermissions.customers;
  return customerPerms.create || 
         customerPerms.view_details || 
         customerPerms.edit || 
         customerPerms.delete;
};

export const hasAnySettingsPermission = (userPermissions) => {
  if (!userPermissions || !userPermissions.settings) {
    return false;
  }
  
  const settingsPerms = userPermissions.settings;
  return Object.values(settingsPerms).some(perm => perm === true);
};

export const hasAnyAPIPermission = (userPermissions) => {
  if (!userPermissions || !userPermissions.api) {
    return false;
  }
  
  const apiPerms = userPermissions.api;
  return apiPerms.create_api_keys || apiPerms.disable_api_keys;
};

export const hasAnyNotesPermission = (userPermissions) => {
  if (!userPermissions || !userPermissions.notes) {
    return false;
  }
  
  const notesPerms = userPermissions.notes;
  return notesPerms.view || notesPerms.create || notesPerms.edit;
};